/**
 * EkonsultacijeCard - Card komponenta sa eKonsultacije stilovima
 *
 * Varijante:
 * - default: Standardna kartica
 * - upload: Upload file kartica
 * - info: Info kartica sa shadow
 * - welcome: Welcome page kartica
 * - error: Error kartica sa crvenim pozadinom
 */

import React from 'react';
import PropTypes from 'prop-types';

export const EkonsultacijeCard = ({
  variant = 'default',
  children,
  className = '',
  ...props
}) => {
  const variants = {
    default: 'bg-white rounded-lg shadow-md',
    upload: 'flex flex-row flex-wrap justify-center rounded-custom min-h-[70vh] bg-white text-center w-[65%] p-[1%]',
    info: 'rounded-lg min-h-card',
    welcome: 'h-[300px] bg-ekonsultacije-bg-card flex flex-col font-medium text-ekonsultacije-primary mx-2',
    error: 'bg-red-50 border border-red-200 rounded-lg shadow-md',
  };

  const cardClasses = `
    ${variants[variant] || variants.default}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

export const EkonsultacijeCardContent = ({
  children,
  className = '',
  ...props
}) => {
  const contentClasses = `
    flex flex-col justify-between gap-2.5 text-justify px-4 py-2
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={contentClasses} {...props}>
      {children}
    </div>
  );
};

EkonsultacijeCard.propTypes = {
  variant: PropTypes.oneOf(['default', 'upload', 'info', 'welcome', 'error']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

EkonsultacijeCardContent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default EkonsultacijeCard;
